import { Component, ElementRef, ViewChild,ChangeDetectorRef } from "@angular/core";
import { AppService } from "src/app/app.service";
import { ChatbotService } from "./../chatbot/chatbot.service";
import { Router, NavigationEnd } from "@angular/router";
import { ExportToExcelService } from "src/app/shared/services/export-to-excel.service";
import { PassScenarioService } from "./../../../shared/services/pass-scenario.service";
import { perCapitaData } from "../../ubc/my-scenario/baseline-contract-details/baseline-contract-constants";
import { ScenarioRefreshService } from "./bot.service";
import { marked } from "marked";
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

// import { MyScenarioService } from "src/app/modules/ubc/my-scenario/my-scenario.service";

@Component({
  selector: 'app-bot',
  templateUrl: './bot.component.html',
  styleUrl: './bot.component.scss'
})
export class BotComponent {
  @ViewChild("chatWindow") chatWindow!: ElementRef;

  scenarioId: number;
  messages: any[] = [];
  userInput = "";
  step = 0;
  currentIntent = "";
  tempData: any = {};
  showInput = false;
  isLoading: boolean = false;
  loaderBgType: string;
  fixedLoader: boolean = false;
  validationError = '';
  newScId: number;
  chatHistory: any[] = [];
  perCapData: any;
  isOpen = false; // Controls if chatbot is open or just the icon is shown
  isMinimized = false;
  // position = { top: 100, left: 100 }; // Default position
  private isDragging = false;
  private dragOffset = { x: 0, y: 0 };
  refreshme: boolean = false; // Used to refresh the component when needed

  showScenarioModal = false;
  scenarioList: any[] = []; // [{name: string, id: number, selected: boolean}]
  pagedScenarios: any[] = [];
  allScenarios: any[] = [];
  scenarioSearch: string = '';
  selectAllChecked = false;
  currentPage = 1;
  totalPages = 1;
  pageSize = 10;
  modalAction: 'refresh' | 'delete' | 'export' | 'duplicate' = 'refresh';
  allProjectNames: string[] = [];
  projectNameSuggestion: string = '';
  filteredProjectNames: string[] = [];
  showDropdown = false;
  private keydownListener: (() => void) | null = null;
  isThinking: boolean = false;
  showConfirmModal = false;
  pendingAction: 'delete' | 'refresh' | null = null;
  position = { left: null, top: null };
  private wasDragged = false;
  selectedChatbotFlow: 'rule' | 'genai' = 'genai';
  sessionId: string | null = null;
  selectedGenAiSubFlow: 'websearch' | 'generic' | null = null;
  ruleMessages: any[] = [];
  genaiMessages: any[] = [];


  constructor(
    private chatbotService: ChatbotService,
    private appService: AppService,
    private exportToExcelService: ExportToExcelService,
    private passScenario: PassScenarioService,
    // public myScenarioService: MyScenarioService,
    // public MyScenarioComponent: MyScenarioComponent,
    private route: Router,
    private scenarioRefreshService: ScenarioRefreshService,
    private cdRef: ChangeDetectorRef,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    // Load saved chat data first
    this.loadChatFromSession();

    // Only add welcome messages if there are no existing messages for the selected flow
    // if (this.selectedChatbotFlow === 'genai' && this.genaiMessages.length === 0 && this.messages.length === 0) {
    //   this.addBotMessage("Welcome to CDS Assistant! Ask me anything for creative dynamic calculations.");
    //   this.step = 1;
    // } else if (this.selectedChatbotFlow === 'rule' && this.ruleMessages.length === 0 && this.messages.length === 0) {
    //   this.addBotMessage("What would you like to do next?", ["Duplicate Scenario", "Export Scenario Data", "Delete Scenario", "Refresh Scenario"]);
    //   this.step = 0;
    // }

    // Set the correct step for the current flow
    if (this.selectedChatbotFlow === 'genai') {
      this.step = 1;
    } else if (this.selectedChatbotFlow === 'rule') {
      this.step = 0;
    }

    this.fetchAllProjectNames();

    this.scenarioRefreshService.scenarioRefreshed$.subscribe((scenarioId: number) => {
      this.addBotMessage(`Scenario ${scenarioId} refreshed!`);
      this.cdRef.detectChanges();
    });

    this.scenarioRefreshService.refreshComplete$.subscribe(() => {
      this.isThinking = false;
      this.cdRef.detectChanges();
      this.resetChat2();
    });

    window.addEventListener('resize', this.onWindowResize);
     this.initSessionId();
     this.loadChatFromSession();
  }

  private readonly STORAGE_KEYS = {
    RULE_MESSAGES: 'chatbot_rule_messages',
    GENAI_MESSAGES: 'chatbot_genai_messages',
    SELECTED_FLOW: 'chatbot_selected_flow',
    SELECTED_GENAI_SUBFLOW: 'chatbot_selected_genai_subflow',
    SESSION_ID: 'chatbot_session_id',
    TIMESTAMP: 'chatbot_timestamp'
  };

  private generateSessionId(): string {
  return 'sess_' + Date.now() + '_' + Math.random().toString(36).substring(2);
  }

  private initSessionId() {
  const storedSessionId = sessionStorage.getItem(this.STORAGE_KEYS.SESSION_ID);

  if (storedSessionId) {
    this.sessionId = storedSessionId;
  } else {
    this.sessionId = this.generateSessionId();
    sessionStorage.setItem(this.STORAGE_KEYS.SESSION_ID, this.sessionId);
  }
  }

  private readonly EXPIRY_TIME = 30 * 60 * 1000;

  private saveChatToSession() {
  try {
    const timestamp = Date.now();
    
    // IMPORTANT: Update flow-specific arrays with current messages before saving
    if (this.selectedChatbotFlow === 'rule') {
      this.ruleMessages = [...this.messages];
    } else if (this.selectedChatbotFlow === 'genai') {
      this.genaiMessages = [...this.messages];
    }
    
    sessionStorage.setItem(this.STORAGE_KEYS.RULE_MESSAGES, JSON.stringify(this.ruleMessages));
    sessionStorage.setItem(this.STORAGE_KEYS.GENAI_MESSAGES, JSON.stringify(this.genaiMessages));
    sessionStorage.setItem(this.STORAGE_KEYS.SELECTED_FLOW, this.selectedChatbotFlow);
    sessionStorage.setItem(this.STORAGE_KEYS.SELECTED_GENAI_SUBFLOW, this.selectedGenAiSubFlow || '');
    sessionStorage.setItem(this.STORAGE_KEYS.SESSION_ID, this.sessionId);
    sessionStorage.setItem(this.STORAGE_KEYS.TIMESTAMP, timestamp.toString());
  } catch (error) {
    console.warn('Failed to save chat data to session storage:', error);
  }
}

private normalizeMessages(messages: any[]) {
  return messages.map(m => {
    const text =
      typeof m.text === 'string'
        ? m.text
        : JSON.stringify(m.text ?? '');

    return {
      ...m,
      text,
      safeHtml: this.sanitizer.bypassSecurityTrustHtml(
        marked.parse(text, { async: false }) as string
      )
    };
  });
}

// Update the loadChatFromSession method
private loadChatFromSession() {
  try {
    // Check if data has expired
    const timestamp = sessionStorage.getItem(this.STORAGE_KEYS.TIMESTAMP);
    if (timestamp) {
      const savedTime = parseInt(timestamp);
      const currentTime = Date.now();
      const timeDiff = currentTime - savedTime;
      
      if (timeDiff > this.EXPIRY_TIME) {
        console.log('Chat data expired after 30 minutes, clearing session storage');
        this.clearChatFromSession();
        return;
      }
    }

    const ruleMessages = sessionStorage.getItem(this.STORAGE_KEYS.RULE_MESSAGES);
    const genaiMessages = sessionStorage.getItem(this.STORAGE_KEYS.GENAI_MESSAGES);
    const selectedFlow = sessionStorage.getItem(this.STORAGE_KEYS.SELECTED_FLOW);
    const selectedGenaiSubFlow = sessionStorage.getItem(this.STORAGE_KEYS.SELECTED_GENAI_SUBFLOW);
    const sessionId = sessionStorage.getItem(this.STORAGE_KEYS.SESSION_ID);

    // Load messages arrays first
    if (ruleMessages) {
    this.ruleMessages = this.normalizeMessages(JSON.parse(ruleMessages));
    }
    if (genaiMessages) {
      this.genaiMessages = this.normalizeMessages(JSON.parse(genaiMessages));
    }
    
    // Only override default flow if there's a saved flow AND it has messages
    if (selectedFlow && (selectedFlow === 'rule' || selectedFlow === 'genai')) {
      const hasRuleMessages = this.ruleMessages.length > 0;
      const hasGenaiMessages = this.genaiMessages.length > 0;
      
      // Only change from default 'genai' if there are actual saved messages for the saved flow
      if ((selectedFlow === 'rule' && hasRuleMessages) || (selectedFlow === 'genai' && hasGenaiMessages)) {
        this.selectedChatbotFlow = selectedFlow as 'rule' | 'genai';
      }
    }
    
    if (selectedGenaiSubFlow) {
      this.selectedGenAiSubFlow = selectedGenaiSubFlow as 'websearch' | 'generic' | null;
    }
    if (sessionId) {
      this.sessionId = sessionId;
    }

    // Restore messages for the selected flow AFTER all properties are set
    if (this.selectedChatbotFlow === 'rule' && this.ruleMessages.length > 0) {
      this.messages = [...this.ruleMessages];
    } else if (this.selectedChatbotFlow === 'genai' && this.genaiMessages.length > 0) {
      this.messages = [...this.genaiMessages];
    }

    if (Array.isArray(this.messages)) {
  this.messages = this.messages.map(m => {
    const text = typeof m.text === 'string'
      ? m.text
      : JSON.stringify(m.text ?? '');

    return {
      ...m,
      text,
      safeHtml: this.sanitizer.bypassSecurityTrustHtml(
        marked.parse(text, { async: false }) as string
      )
    };
  });
}
    
  } catch (error) {
    console.warn('Failed to load chat data from session storage:', error);
  }
}

selectChatbotFlow(flow: 'rule' | 'genai') {
  // Save current messages to appropriate history before switching
  if (this.selectedChatbotFlow === 'rule') {
    this.ruleMessages = [...this.messages];
  } else if (this.selectedChatbotFlow === 'genai') {
    this.genaiMessages = [...this.messages];
  }

  this.selectedChatbotFlow = flow;

  if (flow === 'rule') {
    if (this.ruleMessages.length === 0) {
      this.messages = []; // Clear first
      this.addBotMessage("What would you like to do next?", ["Duplicate Scenario", "Export Scenario Data", "Delete Scenario", "Refresh Scenario"]);
    } else {
      this.messages = [...this.ruleMessages];
    }
    this.step = 0; // Rule-based starts at step 0
  } else if (flow === 'genai') {
    if (this.genaiMessages.length === 0) {
      this.messages = []; // Clear first
      this.addBotMessage("Welcome to Gen AI Based Flow! Ask me anything for creative dynamic calculations.");
    } else {
      this.messages = [...this.genaiMessages];
    }
    this.step = 1; // Gen AI starts at step 1
  }
  
  // Save after switching
  this.saveChatToSession();
}
  // Clear chat data from session storage
  private clearChatFromSession() {
    try {
      Object.values(this.STORAGE_KEYS).forEach(key => {
        sessionStorage.removeItem(key);
      });
    } catch (error) {
      console.warn('Failed to clear chat data from session storage:', error);
    }
  }
  
  selectGenAiSubFlow(flow: 'websearch' | 'generic') {
    if (this.selectedGenAiSubFlow === flow) {
      // Deselect if already selected
      this.selectedGenAiSubFlow = null;
    } else {
      // Select the clicked flow
      this.selectedGenAiSubFlow = flow;
    }

    
  }

  fetchAllProjectNames() {
    this.chatbotService.getAllProjectNames().subscribe((data) => {
      if (data.success && Array.isArray(data.data)) {
        this.allProjectNames = data.data;
      }
    });
  }

  get showChatbot(): boolean {
    return this.appService.loggedInUser?.team === 'UBC';
  }

  get IsGenaiChatbotEnabledd(): boolean {
    return this.appService.resources.IsGenaiChatbotEnabled?.Visible === 'Y';
  }

  onProjectNameInputKeydown(e: KeyboardEvent) {
    if ((e.key === 'Tab' || e.key === 'Enter') && this.projectNameSuggestion) {
      e.preventDefault();
      const typed = this.userInput;
      const suggestion = this.projectNameSuggestion;
      this.userInput = typed + suggestion;
      this.projectNameSuggestion = '';
    }
  }

private toSafeHtml(raw: string): SafeHtml {
  const normalized = String(raw ?? '')
    .replace(/\\n/g, '\n')
    .replace(/\\\\n/g, '\n')
    .replace(/\r/g, '\n');
  const html = marked.parse(normalized) as string;
  return this.sanitizer.bypassSecurityTrustHtml(html);
}

addBotMessage(
  text: string,
  options?: string[],
  html?: string,
  type?: string
) {
  const raw = typeof html === 'string' ? html : (text || '');
  const parsedHtml = marked.parse(raw, { async: false }) as string;

  const safeHtml = this.sanitizer.bypassSecurityTrustHtml(parsedHtml);

  this.messages.push({
    sender: 'bot',
    text : raw,
    safeHtml,
    options,
    type
  });

  this.scrollToBottom();
  this.showInput = false;

  if (this.selectedChatbotFlow) {
    setTimeout(() => this.saveChatToSession(), 0);
  }
}



  addUserMessage(text: string) {
    this.messages.push({ sender: "user", text });
    this.scrollToBottom();

    // Save to session storage after adding message
    if (this.selectedChatbotFlow) {
      setTimeout(() => this.saveChatToSession(), 0);
    }
  }


  handleOptionClick(option: string) {
    this.addUserMessage(option);
    this.currentIntent = option.toLowerCase();

    if (option === 'Duplicate Scenario') {
      this.step = 1;
      this.addBotMessage("Please enter project name to duplicate scenario");
      this.showInput = true;
    } else if (option === 'Export Scenario Data') {
      this.validationError = '';
      this.step = 1;
      this.addBotMessage("Please enter project name to export scenario(s)");
      // this.addBotMessage('Export functionality coming soon.');
    } else if (option === 'Delete Scenario') {
      this.step = 1;
      this.addBotMessage("Please enter project name to delete scenario(s)");
      this.showInput = true;
    }
    else if (option === 'Refresh Scenario') {
      this.step = 1;
      this.addBotMessage("Please enter project name to refresh scenario(s)");
      this.showInput = true;
    }
  }
  handleUserInput() {
    const input = this.userInput.trim();
    if (!input) return;

    this.addUserMessage(input);
    this.showDropdown = false; // Hide the dropdown when sending

    if (this.currentIntent === 'delete scenario' && this.selectedChatbotFlow === 'rule') {

      if (this.step == 1) {
        const projectName = input.trim();
        console.log(projectName);

        const params = {
          projectName: projectName
        }
        this.chatbotService.checkProjectName(params).subscribe((data) => {
          if (data.success) {
            if (data.data.length > 0) {
              // Rx MultiBrand
              this.addBotMessage(`Which scenario would you like to delete in ${projectName}?`);
              this.tempData.projectName = projectName;

              this.chatbotService.getScenariosForProject({ projectName: this.tempData.projectName }).subscribe((data) => {
                if (data.success && data.data.length > 0) {
      
                  const scenarios = data.data.map(s => ({
                    ScenarioID: s.ScenarioID,
                    projectID: s.ProjectID,
                    ModifiedBy: s.ModifiedBy,
                    ScenarioName: s.ScenarioName,
                    ParentType: s.ParentType
                  }));
                  this.openScenarioModal(scenarios,'delete'); // Reuse the modal
                } else {
                  this.addBotMessage("No scenarios found for the selected project. Please enter a valid project name.");
                  this.step = 1;
                }
              });
            } else {
              this.addBotMessage("No project found! Please enter a valid name.");
              this.step = 1;
            }
          } else {
            this.addBotMessage("An error has occurred. Please contact the administrator.");
            this.step = 1;
          }
        })

      } 
    }

    if (this.currentIntent === 'duplicate scenario' && this.selectedChatbotFlow === 'rule') {

      if (this.step == 1) {
        const projectName = input.trim();
        console.log(projectName);

        const params = {
          projectName: projectName
        }
        this.chatbotService.checkProjectName(params).subscribe((data) => {
          if (data.success) {
            if (data.data.length > 0) {
              // Rx MultiBrand
              this.addBotMessage(`Which scenario would you like to duplicate in ${projectName}?`);
              this.tempData.projectName = projectName;
              this.chatbotService.getScenariosForProject({ projectName: this.tempData.projectName }).subscribe((data) => {
                if (data.success && data.data.length > 0) {
      
                  const scenarios = data.data.filter(s => s.ParentType === 'Singleton')
                    .map(s => ({
                      ScenarioID: s.ScenarioID,
                      projectID: s.ProjectID,
                      ModifiedBy: s.ModifiedBy,
                      ScenarioName: s.ScenarioName,
                      ParentType: s.ParentType
                    }));
                  this.openScenarioModal(scenarios,'duplicate'); // Reuse the modal
                } else {
                  this.addBotMessage("No scenarios found for the selected project. Please enter a valid project name.");
                  this.step = 1;
                }
              });
              // this.step = 2;
            } else {
              this.addBotMessage("No project found! Please enter a valid name.");
              this.step = 1;
            }
          } else {
            this.addBotMessage("An error has occurred. Please contact the administrator.");
            this.step = 1;
          }
        })

      } else if (this.step === 2) {
        const scenarioName = input.trim();

        // if (!scenario || !project) {
        //   this.validationError = 'Please enter in format (Case Sensitive): scenarioName, projectName';
        //   return;
        // }

        this.tempData.projectScenarioName = scenarioName;
        this.step = 2;
        this.validationError = ''; // Clear any existing error
        this.showInput = true;
        const param = {
          scenarioName: scenarioName,
          projectName: this.tempData.projectName
        }
        // 13760
        // mm,Rx MultiBrand
        this.chatbotService.checkScenarioName(param).subscribe((data) => {
          // console.log(data);
          if (data.success) {
            if (data.data.length > 0) {
              this.tempData.scenarioId = data.data[0].ScenarioID;
              this.addBotMessage(`Please enter the name for the duplicated scenario`);
              this.step = 3;
              // console.log(this.scenarioId);
            } else {
              this.addBotMessage("No scenario found! Please enter a valid name.");
              this.step = 2;
            }
          } else {
            this.addBotMessage("An error has occurred. Please contact the administrator.");
            this.step = 1;
          }
        })
      }
      else if (this.step === 3) {
        this.tempData.newScenarioName = input;
        this.addBotMessage(
          `Duplicating "${this.tempData.projectScenarioName}" as "${this.tempData.newScenarioName}"...`
        );
        // this.step = 3;
        // this.isLoading = true;
        this.isThinking = true;
        this.loaderBgType = this.appService.loaderColors.pine_green;
        this.fixedLoader = true;
        const param = {
          scenarioId: this.tempData.scenarioId,
          lastDataRefreshDate: this.appService.lastDataRefreshDate,
          newScenarioName: input,
        };
        this.chatbotService.duplicateScenarioById(param).subscribe((data) => {

          if (data.success) {
            this.newScId = data.data[0].ID;
            this.addBotMessage(`Scenario "${this.tempData.newScenarioName}" duplicated successfully.`);
            this.addBotMessage(`Please Click on below link to view the duplicated scenario - `, undefined, `View Scenario`);
          } else {
            this.addBotMessage("An error has occurred. Please contact the administrator.");
          }
          this.step = 1;
          this.loaderBgType = this.appService.loaderColors.pine_green;
          this.fixedLoader = false;
          // this.isLoading = false;
          this.isThinking = false;
          setTimeout(() => { this.resetChat2(); }, 1500);

        });
        this.showInput = false;         
      }
    }
    if (this.currentIntent === 'export scenario data' && this.selectedChatbotFlow === 'rule') {

      if (this.step == 1) {
        const projectName = input.trim();
        console.log(projectName);

        const params = {
          projectName: projectName
        }
        this.chatbotService.checkProjectName(params).subscribe((data) => {
          if (data.success) {
            if (data.data.length > 0) {
              // Rx MultiBrand
              this.addBotMessage(`Which scenarios would you like to export in ${projectName}?`);
              this.tempData.projectName = projectName;

              this.chatbotService.getScenariosForProject({ projectName: this.tempData.projectName }).subscribe((data) => {
                if (data.success && data.data.length > 0) {
      
                  const scenarios = data.data.map(s => ({
                    ScenarioID: s.ScenarioID,
                    projectID: s.ProjectID,
                    ModifiedBy: s.ModifiedBy,
                    ScenarioName: s.ScenarioName,
                    ParentType: s.ParentType
                  }));
                  this.openScenarioModal(scenarios,'export'); // Reuse the modal
                } else {
                  this.addBotMessage("No scenarios found for the selected project. Please enter a valid project name.");
                  this.step = 1;
                }
              });
              this.step = 2;
            } else {
              this.addBotMessage("No project found! Please enter a valid name.");
              this.step = 1;
            }
          } else {
            this.addBotMessage("An error has occurred. Please contact the administrator.");
            this.step = 1;
          }
        })

      }
    }

    if (this.currentIntent === 'refresh scenario' && this.selectedChatbotFlow === 'rule') {

      if (this.step == 1) {
        const projectName = input.trim();
        console.log(projectName);

        const params = {
          projectName: projectName
        }
        this.chatbotService.checkProjectName(params).subscribe((data) => {
          if (data.success) {
            if (data.data.length > 0) {
              // Rx MultiBrand
              this.addBotMessage(`Which scenario would you like to Refresh in ${projectName}?`);
              this.tempData.projectName = projectName;
              this.step = 2;
              this.chatbotService.getrefreshscenarios({ projectName: projectName }).subscribe((data) => {
                if (data.success) {
                  if (data.data.length > 0) {
                    console.log(data.data);
                    const scenarios = data.data.map(s => ({
                      name: s.ScenarioName,
                      id: s.ScenarioID
                    }));

                    setTimeout(() => {
                      this.openScenarioModal(scenarios);
                    }, 2000);

                  } else {
                    this.addBotMessage("No scenarios found for the selected project. Please enter a valid project name.");
                    this.step = 1;
                  }
                } else {
                  this.addBotMessage("An error has occurred. Please contact the administrator.");
                  this.step = 1;
                }
              }
              );

            } else {
              this.addBotMessage("No project found! Please enter a valid name.");
              this.step = 1;
            }
          } else {
            this.addBotMessage("An error has occurred. Please contact the administrator.");
            this.step = 1;
          }
        })

      } 
    }

  if (this.selectedChatbotFlow === 'genai' && this.step === 1) {
  const paramsnew = { query: input, sessionId: this.sessionId, userDetails: {name: this.appService.loggedInUser.name, role :  this.appService.loggedInUser.role} }

  this.isThinking = true;

  // ---------- GENERIC FLOW ----------
  if (this.selectedGenAiSubFlow === 'generic') {
    this.chatbotService.runGenericSearch(paramsnew).subscribe((data) => {

      if (data.success && data.data) {
        let msg: any = data.data;

        if (Array.isArray(msg)) {
          msg = msg
            .map(m => typeof m === 'object' && m.message ? m.message : String(m))
            .join('\n');
        } else if (typeof msg === 'object' && msg.message) {
          msg = msg.message;
        }

        msg = String(msg).replace(/\\n/g, '\n').replace(/\\\\n/g, '\n');
        //msg = String(msg).replace(/\\n/g, '\n').replace(/\\\\n/g, '\n').replace(/"\s*}$/, '').replace(/\s*}$/, '');

       // const html = this.sanitizer.bypassSecurityTrustHtml(marked.parse(msg));
       const html = this.sanitizer.bypassSecurityTrustHtml(marked.parse(msg, { async: false }) as string);
        this.messages.push({ sender: 'bot', text: msg, safeHtml: html });
      }

      this.isThinking = false;
    });
  }

  // ---------- WEB SEARCH FLOW ----------
  else if (this.selectedGenAiSubFlow === 'websearch' && this.userInput.trim()) {
    const query = encodeURIComponent(this.userInput.trim());
    window.open(`https://www.google.com/search?q=${query}`, '_blank');
    this.messages.push({ sender: 'bot', text: "I've opened a web search for you." });
    this.isThinking = false;
  }

  // ---------- NORMAL BOT FLOW ----------
  else {
    this.chatbotService.runUserQueryForbot(paramsnew).subscribe(
      (data) => {

    if (data.data) {
      let msg = data.data;

      if (Array.isArray(msg)) {
        msg = msg.map(m => typeof m === "object" && m.message ? m.message : String(m)).join("\n");
      } else if (typeof msg === "object" && msg.message) {
        msg = msg.message;
      }

       msg = String(msg).replace(/\\\s*\\\s*/g, '\n').replace(/\\n/g, '\n');
      //msg = String(msg).replace(/\\n/g, '\n').replace(/\\\\n/g, '\n').replace(/"\s*}$/, '').replace(/\s*}$/, '');

      this.addBotMessage(msg);

    }
            else {
              this.addBotMessage("No data found or error occurred.");
            }



            this.isThinking = false;
             this.saveChatToSession();
          },
            (err) => {
              console.error('runUserQueryForbot error', err);
              this.addBotMessage("Error occurred, Please try again.");
              this.isThinking = false; // error path
               this.saveChatToSession();
            });
        }



      }

  // Reset user input
  this.userInput = '';
  this.projectNameSuggestion = '';
}


  openScenario(scenarioID?) {
    // console.log(btoa(this.newScId.toString()));
    this.route.navigate(['/ubc/scenario', btoa(this.newScId.toString())]);

  }

  openScenario_existing(scenarioID?: number, refreshme?: boolean) {
    this.route.navigate(
      ['/ubc/scenario', btoa(scenarioID.toString())],
      { queryParams: { refresh: refreshme ? 'true' : 'false' } }
    );
  }

  resetChat2() {
    this.isThinking = false;
    this.projectNameSuggestion = '';
    this.userInput = "";
    this.step = 0;
    this.currentIntent = "";
    this.validationError = '';
    this.tempData = {};
    // this.messages.push({ sender: 'bot', text: '***********************New Conversation**********************' });

    this.addBotMessage('What would you like to do next?', ['Duplicate Scenario', 'Export Scenario Data', 'Delete Scenario', 'Refresh Scenario']);
    this.scrollToBottom();
  }

  resetChat() {
    this.projectNameSuggestion = '';
    this.userInput = "";
    this.step = 0;
    this.currentIntent = "";
    this.validationError = '';
    this.tempData = {};
    if (this.messages.length > 0) {
      this.chatHistory = [...this.messages];
    }
    this.messages = [];
    this.ruleMessages = []; // Clear rule messages

    this.addBotMessage('What would you like to do next?', ['Duplicate Scenario', 'Export Scenario Data', 'Delete Scenario', 'Refresh Scenario']);
    this.scrollToBottom();

    // Save to session storage
    this.saveChatToSession();
  }

  resetgenaiChat() {
    this.projectNameSuggestion = '';
    this.userInput = "";
    this.step = 1;
    this.currentIntent = "";
    this.validationError = '';
    this.tempData = {};
    if (this.messages.length > 0) {
      this.chatHistory = [...this.messages];
    }
    this.messages = [];
    this.genaiMessages = []; // Clear genai messages

    this.addBotMessage('Welcome to Gen AI Based Flow! Ask me anything for creative dynamic calculations.');
    this.scrollToBottom();

    // Save to session storage
    this.saveChatToSession();
  }

  showChatHistory() {
    if (this.chatHistory.length === 0) {
      this.addBotMessage("No previous chat history found.");
    } else {
      // Example: Replay messages (you could customize this further)
      this.addBotMessage("📜 Showing previous chat history:");

      this.chatHistory.forEach(msg => {
        this.messages.push({ ...msg });
      });

      this.scrollToBottom();
    }
  }


  scrollToBottom() {
    setTimeout(() => {
      if (this.chatWindow && this.chatWindow.nativeElement) {
        const element = this.chatWindow.nativeElement;
        element.scrollTop = element.scrollHeight;
      }
    }, 100); // ← short delay ensures message is rendered
  }

  scrollToTop() {
    setTimeout(() => {
      if (this.chatWindow) {
        this.chatWindow.nativeElement.scrollTop = 0;
      }
    });
  }
  isValidFormat(): boolean {
    // Only validate for Step 1 of "Duplicate Scenario"
    // if (this.currentIntent === 'duplicate scenario' && this.step === 1) {
    //   const [scenario, project] = this.userInput.trim().split(',').map((s) => s.trim());
    //   return !!scenario && !!project;
    // }
    // For all other steps, just check that input is not empty
    return this.userInput.trim().length > 0;
  }

  onInputChange(value: string) {
  this.userInput = value;
  this.updateProjectNameSuggestion(value);

  // Show suggestions ONLY when bot is asking for project name
  const isProjectNameStep =
    this.selectedChatbotFlow === 'rule' && this.step === 1 &&
    (
      this.currentIntent === 'duplicate scenario' ||
      this.currentIntent === 'export scenario data' ||
      this.currentIntent === 'delete scenario' ||
      this.currentIntent === 'refresh scenario'
    );

  if (isProjectNameStep && value && this.allProjectNames.length) {
    const lower = value.toLowerCase();
    this.filteredProjectNames = this.allProjectNames
      .filter(name => name.toLowerCase().includes(lower))
      .slice(0, 5);
    this.showDropdown = this.filteredProjectNames.length > 0;
  } else {
    this.filteredProjectNames = [];
    this.showDropdown = false;
  }

  // Validation logic for duplicate scenario intent
  if (this.currentIntent === 'duplicate scenario' && this.step === 1) {
    const [scenario, project] = value.trim().split(',').map(v => v.trim());
    if (!scenario || !project) {
      // this.validationError = 'Please enter in format (Case Sensitive): scenarioName, projectName';
    } else {
      this.validationError = '';
    }
  } else {
    this.validationError = '';
  }
}

updateProjectNameSuggestion(input: string) {
  if (!input) {
    this.projectNameSuggestion = '';
    return;
  }
  const lowerInput = input.toLowerCase();
  const suggestion = this.allProjectNames.find(name =>
    typeof name === 'string' && name.toLowerCase().startsWith(lowerInput)
  );
  if (suggestion && suggestion.length > input.length) {
    // Only show the remaining part (ghosted)
    this.projectNameSuggestion = suggestion.slice(input.length);
  } else {
    this.projectNameSuggestion = '';
  }
}

selectProjectName(name: string) {
  this.userInput = name;
  this.projectNameSuggestion = '';
  this.showDropdown = false;
}


openChatbot() {
  if (this.ruleMessages.length > 0 || this.genaiMessages.length > 0) {
    this.messages =
      this.selectedChatbotFlow === 'rule'
        ? [...this.ruleMessages]
        : [...this.genaiMessages];
  } 
  else {
  this.selectedChatbotFlow = this.appService.resources.IsGenaiChatbotEnabled?.Visible === 'Y' ? 'genai' : 'rule';
  if (this.selectedChatbotFlow === 'genai' && this.genaiMessages.length === 0 && this.messages.length === 0) {
    this.addBotMessage("Welcome to CDS Assistant! Ask me anything for creative dynamic calculations.");
    this.step = 1;
  } else if (this.selectedChatbotFlow === 'rule' && this.ruleMessages.length === 0 && this.messages.length === 0) {
    this.addBotMessage("What would you like to do next?", ["Duplicate Scenario", "Export Scenario Data", "Delete Scenario", "Refresh Scenario"]);
    this.step = 0;
  }

}
  if (this.wasDragged) {
    return;
  }

  const chatbotWidth = 500; // match your SCSS
  const chatbotHeight = 500; // match your SCSS
  const fabHeight = 60; // chatbot-fab height
  const gap = 8; // gap between icon and chat window

  const windowWidth = window.innerWidth;
  const windowHeight = window.innerHeight;

  // Calculate left position (right-aligned, but not out of screen)
  let left = windowWidth - chatbotWidth - 32;
  if (left < 0) left = 8; // clamp to left edge

  // Calculate top position (above icon, but not out of screen)
  let top = windowHeight - chatbotHeight - fabHeight - gap;
  if (top < 0) top = 8; // clamp to top edge

  this.position.left = left;
  this.position.top = top;
  this.isOpen = true;
  this.isMinimized = false;
}

  closeChatbot() {
    this.isOpen = false;
    this.isMinimized = false;
    this.position.left = null;
    this.position.top = null;
  }

  toggleMinimize() {
    this.isMinimized = !this.isMinimized;
  }

  onHeaderMouseDown(event: MouseEvent) {
    event.preventDefault();
    this.isDragging = true;
    this.dragOffset = {
      x: event.clientX - this.position.left,
      y: event.clientY - this.position.top,
    };
    document.addEventListener('mousemove', this.onDragMove);
    document.addEventListener('mouseup', this.onDragEnd);
  }

  onDragMove = (event: MouseEvent) => {
    if (!this.isDragging) return;

    // Get viewport dimensions
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;

    // Chatbot dimensions (should match your SCSS)
    const chatbotWidth = this.isMinimized ? 200 : 500;
    const chatbotHeight = this.isMinimized ? 50 : 500;

    // Clamp left and top so the chatbot stays within the viewport
    let newLeft = event.clientX - this.dragOffset.x;
    let newTop = event.clientY - this.dragOffset.y;

    // Clamp values
    newLeft = Math.max(0, Math.min(newLeft, viewportWidth - chatbotWidth));
    newTop = Math.max(0, Math.min(newTop, viewportHeight - chatbotHeight));

    this.position.left = newLeft;
    this.position.top = newTop;
  };

  onDragEnd = () => {
    this.isDragging = false;
    document.removeEventListener('mousemove', this.onDragMove);
    document.removeEventListener('mouseup', this.onDragEnd);
  };

  ngOnDestroy() {
    // Clean up listeners if component is destroyed
    document.removeEventListener('mousemove', this.onDragMove);
    document.removeEventListener('mouseup', this.onDragEnd);

    if (this.keydownListener) {
      this.keydownListener();
      this.keydownListener = null;
    }

    window.removeEventListener('resize', this.onWindowResize);
  }

  onWindowResize = () => {
    // Chatbot dimensions (should match your SCSS)
    const chatbotWidth = this.isMinimized ? 200 : 500;
    const chatbotHeight = this.isMinimized ? 50 : 500;
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;

    // Clamp left and top so the chatbot stays within the viewport
    let newLeft = this.position.left;
    let newTop = this.position.top;

    if (newLeft + chatbotWidth > viewportWidth) {
      newLeft = Math.max(0, viewportWidth - chatbotWidth);
    }
    if (newTop + chatbotHeight > viewportHeight) {
      newTop = Math.max(0, viewportHeight - chatbotHeight);
    }

    this.position.left = newLeft;
    this.position.top = newTop;
  };


  openScenarioModal(scenarios: any[], action: 'refresh' | 'delete' | 'export' | 'duplicate' = 'refresh') {
    this.scenarioList = scenarios.map(s => ({ ...s, selected: false }));
    this.allScenarios = [...this.scenarioList];
    this.currentPage = 1;
    this.totalPages = Math.ceil(this.scenarioList.length / this.pageSize);
    this.updatePagedScenarios();
    this.showScenarioModal = true;
    this.selectAllChecked = false;
    this.modalAction = action;
    this.scenarioSearch = '';
  }

  closeScenarioModal() {
    this.showScenarioModal = false;
    this.scenarioSearch = '';
  }
  closeScenarioModaloncancel() {
    this.showScenarioModal = false;
    setTimeout(() => {
      this.addBotMessage(`No selection performed !`);
      this.resetChat2();
      this.scenarioList = [];
    }, 1000);
  }
  // updatePagedScenarios() {
  //   const start = (this.currentPage - 1) * this.pageSize;
  //   this.pagedScenarios = this.scenarioList.slice(start, start + this.pageSize);
  // }
  getEndIndex(): number {
    return Math.min(this.currentPage * this.pageSize, this.scenarioList.length);
  }
  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.updatePagedScenarios();
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.updatePagedScenarios();
    }
  }

  toggleSelectAll() {
    this.scenarioList.forEach(s => s.selected = this.selectAllChecked);
    this.updatePagedScenarios();
  }


  onScenarioCheckChange(selectedIndex: number) {
    if (this.modalAction === 'duplicate') {
      const absoluteIndex = (this.currentPage - 1) * this.pageSize + selectedIndex;
      const wasSelected = this.scenarioList[absoluteIndex].selected;
      this.scenarioList.forEach(s => s.selected = false);
      this.scenarioList[absoluteIndex].selected = !wasSelected;
      this.updatePagedScenarios();
    } else {
      const absoluteIndex = (this.currentPage - 1) * this.pageSize + selectedIndex;
      this.scenarioList[absoluteIndex].selected = !this.scenarioList[absoluteIndex].selected;
      this.selectAllChecked = this.scenarioList.every(s => s.selected);
      this.updatePagedScenarios();
    }
  }
  isScenarioCheckboxDisabled(scenario: any): boolean {
    if (this.modalAction === 'duplicate') {
      const selected = this.scenarioList.find(s => s.selected);
      return !!selected && !scenario.selected;
    }
    return false;
  }
  isDeleteOrRefreshDisabled(): boolean {
    if (this.modalAction === 'duplicate') {
      return this.scenarioList.filter(s => s.selected).length !== 1;
    }
    return !this.scenarioList.some(s => s.selected);
  }

  // async confirmScenarioSelection() {
  //   // Get all selected scenarios
  //   const selectedScenarios = this.scenarioList.filter(s => s.selected);

  //   for (let scenario of selectedScenarios) {
  //     await this.refreshScenarioSequentially(scenario.id);
  //   }
  //   // Optionally close modal or show completion message
  //   this.closeScenarioModal();
  // }

  // refreshScenarioSequentially(scenarioId: number): Promise<void> {
  //   return new Promise(resolve => {
  //     // Call your navigation function
  //     this.openScenario_existing(scenarioId, true);

  //     // Wait for scenario to finish refreshing
  //     // You need a way to know when refresh is done, e.g. listen for an event or use a timeout
  //     // Example with timeout (replace with actual completion logic if available)
  //     setTimeout(() => {
  //       resolve();
  //     }, 3000); // Adjust time as needed
  //   });
  // }

  async confirmScenarioSelection2() {
    const selectedScenarios = this.scenarioList.filter(s => s.selected);
  
    if (selectedScenarios.length === 0) {
      this.addBotMessage(`Please select at least one scenario to ${this.modalAction}.`);
      this.openScenarioModal(this.scenarioList, this.modalAction);
      return;
    }

    this.isThinking = true;
    this.cdRef.detectChanges();
  
    if (this.modalAction === 'delete') {
      let deleteCount = 0;
      for (const scenario of selectedScenarios) {
        // You may need to adjust params based on your API
        const deleteParams = {
          ScenarioID: scenario.ScenarioID || scenario.id,
          projectID: scenario.projectID,
          ModifiedBy: scenario.ModifiedBy,
        };
  
        // Choose API based on scenario type if needed
        let deleteObs;
        if (scenario.ParentType === 'Singleton') {
          deleteObs = this.chatbotService.deletesingletonscenario(deleteParams);
        } else {
          deleteObs = this.chatbotService.masterScenarioDelete(deleteParams);
        }
  
        await new Promise<void>((resolve) => {
          deleteObs.subscribe((data) => {
            if (data.success) {
              deleteCount++;
              this.addBotMessage(`Scenario "${scenario.ScenarioName || scenario.name}" deleted successfully.`);
            } else {
              this.addBotMessage(`Failed to delete scenario "${scenario.ScenarioName || scenario.name}".`);
            }
            resolve();
          });
        });
      }
      this.addBotMessage(`Deleted ${deleteCount} scenario(s).`);
      setTimeout(() => {
        this.resetChat2();
        this.updatePagedScenarios();
      }, 3000);
    } else if (this.modalAction === 'refresh') {

        this.isThinking = true;
        this.cdRef.detectChanges();
        
        const selectedScenarios = this.scenarioList.filter(s => s.selected);
        this.addBotMessage(`Refreshing ${selectedScenarios.length} scenario(s)...`);
        const scenarioIds = selectedScenarios.map(s => s.id);

        this.scenarioRefreshService.setQueue(scenarioIds);

        // Start with the first scenario
        const firstId = this.scenarioRefreshService.getNextScenario();
        if (firstId) {
          this.openScenario_existing(firstId, true);
        }
          setTimeout(() => {
          this.closeScenarioModal();
            }, 300);
    } else if (this.modalAction === 'export') {
      let exportCount = 0;

      for (const scenario of selectedScenarios) {
        const params = {
          scenarioId: scenario.ScenarioID,
          lastDataRefreshDate: this.appService.lastDataRefreshDate,
          resources: this.appService.resources,
          perCapitaData: this.passScenario.getBaseline(),
        };

        try {
          if (scenario.ParentType === 'Singleton') {
            await new Promise<void>((resolve) => {
              this.chatbotService.exportScenarioById(params).subscribe({
                next: (data) => {
                  try {
                    if (data.success) {
                      const dataToExport = data.data;
                      this.exportToExcelService.exportFile(data.scenario, dataToExport, false, 'UBC');
                      exportCount++;
                      this.addBotMessage(`Singleton scenario "${scenario.ScenarioName}" exported successfully.`);
                    } else {
                      this.addBotMessage(`Failed to export singleton scenario "${scenario.ScenarioName}".`);
                    }
                  } catch (err) {
                    this.addBotMessage(`Error exporting singleton scenario "${scenario.ScenarioName}": ${err?.message || err}`);
                  }
                  resolve();
                },
                error: (err) => {
                  this.addBotMessage(`Error exporting singleton scenario "${scenario.ScenarioName}": ${err?.message || 'Unknown error'}`);
                  resolve();
                }
              });
            });
          } else {
            await new Promise<void>((resolve) => {
              this.chatbotService.exportMasterScenarioById(params).subscribe({
                next: (data) => {
                  try {
                    if (data.success) {
                      const masterScenario = { MasterScName: scenario.ScenarioName };
                      const dataToExport = data.data;
                      this.exportToExcelService.exportFile(masterScenario, dataToExport, true, 'UBC');
                      exportCount++;
                      this.addBotMessage(`Parent scenario "${scenario.ScenarioName}" exported successfully.`);
                    } else {
                      this.addBotMessage(`Failed to export parent scenario "${scenario.ScenarioName}".`);
                    }
                  } catch (err) {
                    this.addBotMessage(`Error exporting parent scenario "${scenario.ScenarioName}": ${err?.message || err}`);
                  }
                  resolve();
                },
                error: (err) => {
                  this.addBotMessage(`Error exporting parent scenario "${scenario.ScenarioName}": ${err?.message || 'Unknown error'}`);
                  resolve();
                }
              });
            });
          }
        } catch (err) {
          this.addBotMessage(`Unexpected error exporting "${scenario.ScenarioName}": ${err?.message || err}`);
          // Continue to next scenario even if one fails
        }
  }

  this.addBotMessage(`Exported ${exportCount} scenario(s).`);
  setTimeout(() => {
    this.resetChat2();
    this.updatePagedScenarios();
  }, 3000);
    } else if (this.modalAction === 'duplicate') {
      this.isThinking = false;
      this.tempData.projectScenarioName = selectedScenarios[0].ScenarioName;
      this.tempData.scenarioId = selectedScenarios[0].ScenarioID;
      this.addBotMessage(`Please enter the name for the duplicated scenario`);
      this.showInput = true;
      this.step = 3;

    }

    // this.isThinking = false;
    this.closeScenarioModal();
  }

  getScenarioSelectionLabel(action: string): string {
    switch (action?.toLowerCase()) {
      case 'delete':
        return 'Select scenarios to delete';
      case 'export':
        return 'Select scenarios to export';
      case 'refresh':
        return 'Select scenarios to refresh';
      case 'duplicate':
        return 'Select scenario to duplicate';
      default:
        return 'Select scenarios';
    }
  }


  paginationPages: number[] = [];

  updatePagedScenarios() {
    const start = (this.currentPage - 1) * this.pageSize;
    this.pagedScenarios = this.scenarioList.slice(start, start + this.pageSize);
    this.totalPages = Math.ceil(this.scenarioList.length / this.pageSize);
    this.generatePaginationPages();
  }

  generatePaginationPages() {
  const pages: number[] = [];
  const maxPagesToShow = 3;
  let startPage = Math.max(1, this.currentPage - 1);
  let endPage = Math.min(this.totalPages, startPage + maxPagesToShow - 1);

  if (endPage - startPage < maxPagesToShow - 1) {
    startPage = Math.max(1, endPage - maxPagesToShow + 1);
  }

  for (let i = startPage; i <= endPage; i++) {
    pages.push(i);
  }
  this.paginationPages = pages;
}

  goToPage(page: number) {
    if (page < 1 || page > this.totalPages) return;
    this.currentPage = page;
    this.updatePagedScenarios();
  }

  filterScenarios() {
    const search = this.scenarioSearch.trim().toLowerCase();
    if (!search) {
      this.scenarioList = [...this.allScenarios];
    } else {
      this.scenarioList = this.allScenarios.filter(s =>
        (s.ScenarioName || s.name || '').toLowerCase().includes(search)
      );
    }
    this.currentPage = 1;
    this.totalPages = Math.ceil(this.scenarioList.length / this.pageSize);
    this.updatePagedScenarios();
  }


handleScenarioAction() {
  if (this.modalAction === 'delete' || this.modalAction === 'refresh') {
    this.pendingAction = this.modalAction;
    this.showConfirmModal = true;
    this.showScenarioModal = false;      // Hide scenario modal
  } else {
    this.confirmScenarioSelection2();
    this.closeScenarioModal();
  }
}

closeConfirmModal() {
  this.showConfirmModal = false;
  this.showScenarioModal = true;  
  this.pendingAction = null;
}

confirmWarningYes() {
  this.showConfirmModal = false;
  this.pendingAction = null;
  this.confirmScenarioSelection2();
  this.closeScenarioModal();
}

onFabMouseDown(event: MouseEvent) {
  event.preventDefault();

  // If position is not set, calculate it from the button's current position
  if (this.position.left === null || this.position.top === null) {
    const fab = (event.target as HTMLElement).closest('.chatbot-fab') as HTMLElement;
    if (fab) {
      const rect = fab.getBoundingClientRect();
      this.position.left = rect.left;
      this.position.top = rect.top;
    }
  }

  this.isDragging = true;
  this.wasDragged = false; // Reset drag flag
  this.dragOffset = {
    x: event.clientX - this.position.left,
    y: event.clientY - this.position.top,
  };
  document.addEventListener('mousemove', this.onFabDragMove);
  document.addEventListener('mouseup', this.onFabDragEnd);
}

onFabDragMove = (event: MouseEvent) => {
  if (!this.isDragging) return;
  this.wasDragged = true; // Set drag flag if mouse moves
  const fabWidth = 60;
  const fabHeight = 60;
  const viewportWidth = window.innerWidth;
  const viewportHeight = window.innerHeight;

  let newLeft = event.clientX - this.dragOffset.x;
  let newTop = event.clientY - this.dragOffset.y;

  newLeft = Math.max(0, Math.min(newLeft, viewportWidth - fabWidth));
  newTop = Math.max(0, Math.min(newTop, viewportHeight - fabHeight));

  this.position.left = newLeft;
  this.position.top = newTop;
};

onFabDragEnd = () => {
  this.isDragging = false;
  setTimeout(() => { this.wasDragged = false; }, 0); // Reset after drag ends
  document.removeEventListener('mousemove', this.onFabDragMove);
  document.removeEventListener('mouseup', this.onFabDragEnd);
};


  clearChatHistory() {
    this.clearChatFromSession();
    this.ruleMessages = [];
    this.genaiMessages = [];
    this.messages = [];
    this.selectedChatbotFlow = 'genai';
    this.selectedGenAiSubFlow = null;
    this.sessionId = null;
  }


}
